module.exports = __webpack_public_path__ + "static/zh-4f3b7da71a2667b0d4c990e9f2e211bb.jpg";